module.exports = __webpack_public_path__ + "static/1-16c0658aa8bead000bb36a906d4fbecc.png";